var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDirecoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "direcc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-648.000000, -6211.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(162.000000, 5902.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(429.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "direcc",
    transform: "translate(67.500000, 21.500000) rotate(40.000000) translate(-67.500000, -21.500000) translate(61.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.267880406,9.60443551 C-0.744261318,11.5903151 1.30096289,13.7495082 3.2414828,12.7457363 L5.5030958,11.5758734 C6.13132166,11.2509113 6.87123293,11.2509113 7.49945879,11.5758734 L9.76107179,12.7457363 C11.7015917,13.7495082 13.7398352,11.5903151 12.7346738,9.60443551 L8.47669878,1.23485609 C7.63906424,-0.41161864 5.36349035,-0.41161864 4.52585581,1.23485609 L0.267880406,9.60443551 Z",
    id: "Vector"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirecoes);
export default __webpack_public_path__ + "static/media/icon_direcoes.a3cd3e78cd542da1d20afbda839e5343.svg";
export { ForwardRef as ReactComponent };